import { Autocomplete, Button, Group, NumberInput, SimpleGrid, Stack, Textarea, TextInput } from '@mantine/core';
import { IconScan } from '@tabler/icons-react';
import { useState } from 'react';
import { useSeja } from '../seja/useSeja';
import { OknoBranja } from '../vozila/BranjeDokumentov';
import { izDokumenta, obrezano, velike, type VoziloStranke } from './delavnica';

/** Pogosta goriva za izbiro (vpisati je mogoče tudi drugo). */
const GORIVA = ['Bencin', 'Dizel', 'Hibrid', 'Priključni hibrid', 'Električno', 'Plin (LPG)'];

/**
 * Polja vozila stranke (sprejem vozila in zaslon vozila). Napake strežnika so po imenu lastnosti, pri sprejemu s
 * predpono »vozilo.« ({@code predpona}).
 */
export function PoljaVozila({
  vozilo,
  nastavi,
  polja,
  predpona = '',
}: {
  vozilo: VoziloStranke;
  nastavi: (v: VoziloStranke) => void;
  polja: Record<string, string>;
  predpona?: string;
}) {
  const stanje = useSeja();
  const ai = stanje.status === 'prijavljen' && !!stanje.instanca.umetnaInteligenca;
  const [branje, setBranje] = useState(false);
  // registrska, VIN, znamka in model z velikimi črkami že med tipkanjem; presledki na robovih se odrežejo ob izhodu
  const besedilo = (k: 'registrska' | 'vin' | 'znamka' | 'model' | 'motor', oznaka: string, obvezno = false) => (
    <TextInput
      label={oznaka}
      value={vozilo[k] ?? ''}
      onChange={(e) => {
        const v = e.currentTarget.value;
        nastavi({ ...vozilo, [k]: k === 'motor' ? v : velike(v) });
      }}
      onBlur={() => nastavi({ ...vozilo, [k]: obrezano(vozilo[k]) })}
      error={polja[predpona + k]}
      withAsterisk={obvezno}
    />
  );
  const stevilo = (k: 'letnik' | 'km', oznaka: string) => (
    <NumberInput
      label={oznaka}
      value={vozilo[k] ?? ''}
      onChange={(v) => nastavi({ ...vozilo, [k]: typeof v === 'number' ? v : undefined })}
      error={polja[predpona + k]}
      allowDecimal={false}
      allowNegative={false}
      thousandSeparator={k === 'km' ? '.' : undefined}
      decimalSeparator=","
    />
  );
  return (
    <Stack gap="sm">
      {ai && (
        <Group>
          <Button variant="light" leftSection={<IconScan size={18} />} onClick={() => setBranje(true)}>
            Preberi iz prometnega dovoljenja
          </Button>
          <OknoBranja
            odprto={branje}
            zapri={() => setBranje(false)}
            delavnica
            prebrano={(r) => nastavi(izDokumenta(vozilo, r.vozilo))}
          />
        </Group>
      )}
      <SimpleGrid cols={{ base: 1, xs: 2 }} spacing="sm">
        {besedilo('registrska', 'Registrska številka', true)}
        {besedilo('vin', 'Številka šasije (VIN)')}
        {besedilo('znamka', 'Znamka')}
        {besedilo('model', 'Model')}
        {stevilo('letnik', 'Letnik')}
        {stevilo('km', 'Kilometri')}
        {besedilo('motor', 'Motor')}
        <Autocomplete
          label="Gorivo"
          data={GORIVA}
          value={vozilo.gorivo ?? ''}
          onChange={(v) => nastavi({ ...vozilo, gorivo: v })}
          onBlur={() => nastavi({ ...vozilo, gorivo: obrezano(vozilo.gorivo) })}
          error={polja[predpona + 'gorivo']}
        />
        <Textarea
          label="Opomba"
          value={vozilo.opomba ?? ''}
          onChange={(e) => nastavi({ ...vozilo, opomba: e.currentTarget.value })}
          onBlur={() => nastavi({ ...vozilo, opomba: obrezano(vozilo.opomba) })}
          error={polja[predpona + 'opomba']}
          autosize
          minRows={2}
          style={{ gridColumn: '1 / -1' }}
        />
      </SimpleGrid>
    </Stack>
  );
}
